import React from 'react';
import { useDarkMode } from '../../contexts/DarkModeContext';
import './Ads.css';

const Ads = () => {
  const { isDarkMode } = useDarkMode();

  return (
    <section className={`ads-section ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
      <div className="ads-container">

      </div>
    </section>
  );
};

export default Ads; 